import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    ItemDescription: { label: i18n.t('products.ItemDescription'), value: '' },
    UnitOfMeasure: { label: i18n.t('products.UnitOfMeasure'), value: '' },
    ArticleCode: { label: i18n.t('products.ArticleCode'), value: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'selected', width: '50px', headerSelectionValue: false, locked: true, lockable: false, columnMenu: false, reorderable: false, groupable: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      }, 
    },
    {
      field: 'Cliente',
      width: '250px',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'ItemDescription', title: i18n.t('products.ItemDescription'), columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'UnitOfMeasure', title: i18n.t('products.UnitOfMeasure'), format: 'TIPOS_UNIDADES_MEDIDA', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '350px', locked: false, sortable: false, groupable: false },
    { field: 'UnitPriceWithoutTax', title: i18n.t('products.UnitPriceWithoutTax'), format: 'currency', cell: 'numberTemplate', columnMenu: 'myTemplate', width: '425px', locked: false },
    { field: 'ArticleCode', title: i18n.t('products.ArticleCode'), columnMenu: 'myTemplate', width: '300px', locked: false },
    { field: 'idProducto', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
  ] 
}
const mystore = parent({ navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
